// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"06ede02c","703":"62e09b9f","787":"0aa9d20a"}[chunkId] + ".chunk.js";
};